export const formatPhoneNumber = (phoneNumber: string) => {
    if (phoneNumber.length === 7) {
        const firstSegment = phoneNumber.substring(0, 3);
        const secondSegment = phoneNumber.substring(3);
        return `${firstSegment}-${secondSegment}`;
    }
    if (phoneNumber.length === 10) {
        const firstSegment = phoneNumber.substring(0, 3);
        const secondSegment = phoneNumber.substring(3, 6);
        const thirdSegment = phoneNumber.substring(6);
        return `(${firstSegment}) ${secondSegment}-${thirdSegment}`;
    }
    return phoneNumber;
};

export const isPhoneHaveLetters = (phone: string) => {
    const haslettersRegex = /\p{L}/u; // catches unwanted unicode characters as well as letters
    return haslettersRegex.test(phone);
};
